module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-kepler-file-upload"
  }, [(_vm.previewUrl) ? _c('div', {
    staticClass: "preview"
  }, [(_vm.canPreview) ? _c('div', {
    staticClass: "preview-image",
    style: (_vm.previewStyle)
  }) : _c('div', {
    staticClass: "download-file"
  }, [_c('a', {
    on: {
      "click": _vm.openUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o fa-3x"
  }), _c('br'), _c('small', [_vm._v(_vm._s(_vm.previewUrl))])])]), (!_vm.previewOnly) ? _c('button', {
    staticClass: "button alert small",
    on: {
      "click": function($event) {
        return _vm.$emit('sel', null)
      }
    }
  }, [_vm._v("Remove")]) : _vm._e()]) : _vm._e(), (!_vm.previewOnly) ? _c('div', {
    staticClass: "uploader"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    ref: "file",
    staticClass: "input-group-field",
    attrs: {
      "type": "file"
    }
  }), _c('div', {
    staticClass: "input-group-button"
  }, [_c('input', {
    staticClass: "button",
    attrs: {
      "type": "submit",
      "value": "Upload"
    },
    on: {
      "click": _vm.startUpload
    }
  })])]), _c('button', {
    staticClass: "button small",
    on: {
      "click": function($event) {
        _vm.advanced = !_vm.advanced
      }
    }
  }, [_vm._v("ADVANCED")])]) : _vm._e(), (_vm.advanced) ? _c('div', {
    staticClass: "advanced-upload"
  }, [_c('label', [_vm._v("VISIBILITY"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visibility),
      expression: "visibility"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visibility = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.visibilityOptions), function(o) {
    return _c('option', [_vm._v(_vm._s(o))])
  }), 0)]), _c('label', [_vm._v("PREFIX"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prefix),
      expression: "prefix"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.prefix = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null",
      "selected": "selected"
    }
  }, [_vm._v("no_prefix")]), _vm._l((_vm.prefixOptions), function(o) {
    return _c('option', [_vm._v(_vm._s(o))])
  })], 2)]), _c('label', [_vm._v("FILENAME"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filename),
      expression: "filename"
    }],
    attrs: {
      "type": "text",
      "placeholder": "filename"
    },
    domProps: {
      "value": (_vm.filename)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filename = $event.target.value
      }
    }
  })]), (_vm.response) ? _c('div', {
    staticClass: "square"
  }, [_c('img', {
    attrs: {
      "src": _vm.response.external_url
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "uploaded-gallery"
  }, _vm._l((_vm.listing), function(l) {
    return _c('div', {
      staticClass: "square"
    }, [_c('div', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.deleteFile(l.internal_path)
        }
      }
    }, [_c('div', {
      staticClass: "fa fa-times"
    })]), (_vm.preview(l.internal_path)) ? _c('img', {
      attrs: {
        "src": l.external_url,
        "alt": l.internal_path
      },
      on: {
        "click": function($event) {
          return _vm.imageSelected(l)
        }
      }
    }) : _c('div', {
      staticClass: "other-file",
      on: {
        "click": function($event) {
          return _vm.imageSelected(l)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o fa-3x"
    }), _c('small', {
      staticClass: "internal-path"
    }, [_vm._v(_vm._s(l.internal_path))])])])
  }), 0)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5a593a61!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/KeplerFileUpload.vue
// module id = 2371
// module chunks = 1